<div class="install-bid-detail w-full" *ngIf="projectInstallBidDetails">
  <div class="flex flex-1 justify-between w-full">
    <div><button *ngIf="!multiView" mat-button color="primary" class="m-2 text-xs" [routerLink]="['/', 'installer', installerId, 'bids']"><mat-icon>arrow_back</mat-icon>All Bids</button></div>
    <div><button *ngIf="multiView" mat-button color="primary" class="text-xs" [routerLink]="['/', 'installer', installerId, 'bid', projectInstallBidDetails.id]"><mat-icon>arrow_forward</mat-icon></button></div>
  </div>
  <div class="flex flex-row p-4">
    <div class="flex flex-col mr-4">
      <div class="flex flex-col">
        <div class="font-bold mb-2" *ngIf="!projectInstallBidDetails.bidSequence || projectInstallBidDetails.bidSequence == 0">{{ projectInstallBidDetails.project.installDate | date : 'fullDate' }} {{ projectInstallBidDetails.project.installStartTime | timeFormat }}</div>
        <div class="font-bold mb-2" *ngIf="projectInstallBidDetails.bidSequence && projectInstallBidDetails.bidSequence > 0">{{ (projectInstallBidDetails.installDate) ? (projectInstallBidDetails.installDate | date : 'shortDate') : 'Invalid Date' }}</div>
        <div class="mb-4" *ngIf="!projectInstallBidDetails.bidSequence || projectInstallBidDetails.bidSequence == 0">Bid Due: {{ dueDate | date : 'shortDate' }} ({{expiredDays}})</div>
        <div class="flex flex-row justify-between mb-2 font-bold">{{ projectInstallBidDetails.title }}</div>
        <div class="mb-2">{{ projectInstallBidDetails.description }}</div>
        <ng-container *ngIf="projectInstallBidDetails.request.bidStatus !== 'REJECTED' && (!projectInstallBidDetails.bidSequence || projectInstallBidDetails.bidSequence == 0)">
          <div>{{ projectInstallBidDetails.project.name }}</div>
          <div>{{ projectInstallBidDetails.project.address1 }}</div>
          <div *ngIf="projectInstallBidDetails.project.address2">{{ projectInstallBidDetails.project.address2 }}</div>
          <div>{{ projectInstallBidDetails.project.city }} {{ projectInstallBidDetails.project.state }}, {{ projectInstallBidDetails.project.postal }} {{ projectInstallBidDetails.project.country }}</div>
          <div class="flex flex-row flex-wrap my-4">
            Shift:
            <ng-container *ngIf="projectInstallBidDetails.project.nightWork">Night <mat-icon class="mr-4">dark_mode</mat-icon></ng-container>
            <ng-container *ngIf="!projectInstallBidDetails.project.nightWork">Day <mat-icon class="mr-4">light_mode</mat-icon></ng-container>
            Union:
            {{ projectInstallBidDetails.project.union ? 'Yes' : 'No' }}
            <mat-icon *ngIf="projectInstallBidDetails.project.union">handshake</mat-icon>
          </div>
          <div *ngIf="projectInstallBidDetails.project.stockPermitReq || projectInstallBidDetails.project.specialInspection" class="flex flex-row flex-wrap mb-4">
            <mat-icon
              *ngIf="projectInstallBidDetails.project.stockPermitReq"
              [ngClass]="{'not-complete': !projectInstallBidDetails.project.installPermitPickup}"
              [matTooltip]="projectInstallBidDetails.project.installPermitPickup ? 'Permit complete' : 'Permit not complete'"
            >fact_check</mat-icon
            >
            <mat-icon
              *ngIf="projectInstallBidDetails.project.specialInspection"
              [ngClass]="{'not-complete': !projectInstallBidDetails.project.installInspection}"
              [matTooltip]="projectInstallBidDetails.project.installInspection ? 'Inspection complete' : 'Inspection not complete'"
            >verified</mat-icon
            >
          </div>
          <div>
            <a *ngFor="let attachment of projectInstallBidDetails.attachments"
              class="flex underline cursor-pointer font-medium"
              (click)="downloadFile($event, attachment.fileHash)"
            >
              <mat-icon class="">description</mat-icon>
              <div class="pb-1">{{ attachment.fileName }}</div>
            </a>
          </div>
          <div class="flex flex-row justify-between items-center p-4 mt-4">
            <div class="font-bold">Questions:</div>
            <div class="flex">
              <button *ngIf="!locked" mat-stroked-button class="mx-2" [disabled]="busy" (click)="getQuestions()">
                <mat-icon *ngIf="busy"><mat-spinner diameter="15"></mat-spinner></mat-icon>
                <mat-icon *ngIf="!busy">refresh</mat-icon>
                Refresh
              </button>
              <button *ngIf="!busy && !locked" mat-raised-button color="primary" (click)="askQuestion()">Ask Question</button>
            </div>
          </div>
          <app-install-question *ngFor="let question of projectInstallBidDetails.questions" (updateQuestionEmitter)="handleUpdateQuestionEmitter()"
                            [locked]="locked" [installerId]="installerId" [installBidId]="installBidId" [question]="question">
          </app-install-question>
        </ng-container>
        <div class="flex flex-row justify-between mt-4" *ngIf="!projectInstallBidDetails.bidSequence || projectInstallBidDetails.bidSequence == 0">
          <div class="content-end">
            <button
              mat-raised-button
              (click)="retractInstall()"
              *ngIf="editMode && !busy && !locked && projectInstallBidDetails.request.bidAmount">Retract</button>
            <div *ngIf="enableEditCrew && !crewEditMode" class="flex flex-row justify-between mb-2">
              <span class="self-center" *ngIf="!installCrew">Crew not specified.</span>
              <div *ngIf="installCrew" class="flex flex-col">
                <span>{{installCrew.fullName}}</span>
                <span>{{installCrew.email}}</span>
                <span>{{installCrew.phone}}</span>
              </div>
              <button mat-icon-button class="small-icon-button" (click)="editCrew()">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
            <div *ngIf="enableEditCrew && crewEditMode" class="flex flex-row justify-between mb-2">
              <mat-form-field appearance="outline">
                <mat-label>Crew Member</mat-label>
                <mat-select [(ngModel)]="selectedCrew">
                  <!--mat-option /-->
                  <mat-option> </mat-option>
                  <div *ngFor="let crew of installerCrew">
                    <mat-option class="w-full" [value]="crew">
                      {{ crew.fullName }}
                    </mat-option>
                  </div>
                </mat-select>
              </mat-form-field>
              <div class="flex">
                <button *ngIf="!crewBusy" mat-icon-button class="small-icon-button" (click)="cancelEditCrew()">
                  <mat-icon>cancel</mat-icon>
                </button>
                <button *ngIf="!crewBusy" mat-icon-button class="small-icon-button" (click)="saveCrew()">
                  <mat-icon>save</mat-icon>
                </button>
                <div *ngIf="crewBusy">
                  <mat-spinner diameter="20"></mat-spinner>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-2">
            <div *ngIf="editMode && !locked"  [formGroup]="bidRequestForm">
              <mat-form-field appearance="outline" class="mr-2">
                <span matPrefix class="ml-3 text-gray-500">$</span>
                <mat-label>Bid Amount</mat-label>
                <input matInput type="text" maxlength="10" formControlName="bidAmount" />
              </mat-form-field>
            </div>
            <div *ngIf="!editMode || locked" class="flex flex-col">
              <div class="flex flex-row justify-between mb-2 font-bold items-center">
                <span>{{projectInstallBidDetails.request.bidStatus}}</span>
                <span *ngIf="projectInstallBidDetails.request.bidAmount">: {{ (projectInstallBidDetails.request.bidStatus === 'ACCEPTED') ? (projectInstallBidDetails.request.bidAmountAwarded | currency:'USD':'symbol':'1.0-0') : (projectInstallBidDetails.request.bidAmount | currency) }}</span>
                <button mat-icon-button *ngIf="!locked" class="small-icon-button" (click)="editForm()">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
              <div *ngIf="projectInstallBidDetails.request.bidStatus === 'ACCEPTED' && projectInstallBidDetails.request.bidAmount !== projectInstallBidDetails.request.bidAmountAwarded"
                   class="flex flex-row justify-end mb-2 font-normal text-xs items-center">
                <span>Orig:</span>
                <span>{{ projectInstallBidDetails.request.bidAmount | currency:'USD':'symbol':'1.0-0' }}</span>
              </div>
            </div>
            <div class="flex justify-end items-center">
              <button *ngIf="complianceWarning" mat-icon-button class="mr-2" color="warn" [routerLink]="['/', 'installer', installerId, 'company']" [matTooltip]="complianceWarning"><mat-icon>warning</mat-icon></button>
              <button mat-button *ngIf="editMode && (projectInstallBidDetails.request.bidAmount || projectInstallBidDetails.request.bidStatus !== 'PENDING') && projectInstallBidDetails.request.bidStatus !== 'REJECTED'"
                      class="mr-2" (click)="cancelEdit()">Cancel</button>
              <button
                mat-raised-button
                (click)="noBid()"
                class="mr-2"
                *ngIf="editMode && !busy && !locked"
              >Not Bidding</button>
              <button
                mat-raised-button
                color="primary"
                (click)="sendBidAmount()"
                [disabled]="!bidRequestForm.valid"
                *ngIf="editMode && !busy && !locked"
              >
                Send Bid {{(bidRequestForm.controls.bidAmount.value && bidRequestForm.controls.bidAmount.valid) ? '$' + (bidRequestForm.controls.bidAmount.value | number) : ''}}
              </button>
              <mat-icon *ngIf="busy"><mat-spinner diameter="15"></mat-spinner></mat-icon>
            </div>
          </div>
        </div>
        <div class="flex flex-col mt-4" *ngIf="projectInstallBidDetails.bidSequence && projectInstallBidDetails.bidSequence > 0">
          <div class="flex flex-row mb-2 font-bold items-center">
            <span>Cancelled</span>
          </div>
          <div *ngIf="projectInstallBidDetails.bidCancelReason" class="flex flex-row items-start gap-2 p-3 rounded bg-red-50 border border-red-200 text-red-800">
            <mat-icon class="text-red-500 shrink-0" style="font-size: 18px; height: 18px; width: 18px;">info</mat-icon>
            <span class="text-sm">{{projectInstallBidDetails.bidCancelReason}}</span>
          </div>
        </div>
        </div>
    </div>
  </div>
</div>
